<!-- start app-validation -->
<p 
    [style]="style"
     class="invalid text_md_bold {{class}}"
>
     {{text || 'يوجد خطاء!'}}
</p>
<!-- end app-validation -->
